module.exports = __webpack_public_path__ + "static/media/melodykakao.e13623fe.mp3";